import { normalizeDomain } from '@/lib/normalize-domain';

/** The logo image for a domain, or null without one. */
export function companyLogoUrl(domain?: string | null): string | null {
  const cleanDomain = normalizeDomain(domain);
  // fallback=404: a domain without a logo answers 404 instead of a white
  // monogram, so the themed fallback shows (and dark mode stays dark).
  return cleanDomain
    ? `https://img.logo.dev/${cleanDomain}?token=pk_SQQ2koEUSE-cmBXPIycW-A&fallback=404`
    : null;
}
